/**
 * Shared TypeScript types for the billing feature, mirroring the Pydantic
 * schemas in `apps/api/src/app/schemas/billing.py`. Keep these in sync when
 * the backend schema changes.
 */

export type PlanKind =
  | 'trial'
  | 'one_time'
  | 'subscription_month'
  | 'subscription_year';

export interface Plan {
  id: number;
  slug: string;
  name: string;
  description: string;
  kind: PlanKind | string;
  price_cents: number;
  currency: string;
  tokens: number;
  is_subscription: boolean;
  duration_days: number;
  display_order: number;
}

export interface TokenTransaction {
  id: number;
  delta: number;
  balance_after: number;
  reason: string;
  note: string;
  plan_id: number | null;
  created_at: string;
}

export interface BillingMe {
  tokens_balance: number;
  subscription_status: string;
  subscription_plan_id: number | null;
  subscription_plan_slug: string | null;
  subscription_expires_at: string | null;
  subscription_active: boolean;
}

export interface CheckoutResponse {
  purchase_id: number;
  plan_slug: string;
  status: string;
  tokens_credited: number;
  new_balance: number;
  subscription_expires_at: string | null;
}

/** Mirrors `PurchaseOut` in `apps/api/src/app/schemas/billing.py`. */
export interface Purchase {
  id: number;
  plan_id: number;
  plan_slug: string;
  plan_name: string;
  amount_cents: number;
  currency: string;
  /** 'pending' | 'paid' | 'failed' | 'refunded' */
  status: string;
  culqi_charge_id: string;
  created_at: string;
}

export function formatPrice(cents: number, currency = 'PEN'): string {
  const value = (cents / 100).toFixed(2);
  return currency === 'PEN' ? `S/. ${value}` : `${value} ${currency}`;
}
